import React, { Component } from "react";
import CurrencyInput from "elevate-ui/CurrencyInput";
import withStyles from "elevate-ui/withStyles";
import NumberIncrement from "elevate-ui/NumberIncrement";

class DownPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalPrice: props.form.values.totalPrice,
      percentage: 20,
      downPayment: props.field.value,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.form.values.totalPrice !== prevProps.form.values.totalPrice
    ) {
      this.setState({ totalPrice: this.props.form.values.totalPrice }, () =>
        this.calculateFromTotalPrice()
      );
    }
  }

  calculateFromTotalPrice = () => {
    const { totalPrice, percentage } = this.state;
    const downPayment = totalPrice * (percentage * 0.01);
    this.setState({ downPayment });
  };

  calculateValuesFromPercent = (percentage) => {
    const downPayment = this.state.totalPrice * (percentage * 0.01);
    this.setState({ downPayment, percentage }, () =>
      this.props.form.setFieldValue("downPayment", downPayment)
    );
  };

  calculatePercentfromValues = (downPayment) => {
    const percentage = (downPayment / this.state.totalPrice) * 100;
    this.setState({ downPayment, percentage: percentage.toFixed(2) }, () =>
      this.props.form.setFieldValue("downPayment", downPayment)
    );
  };

  render() {
    const { classes } = this.props;
    const { downPayment, percentage } = this.state;
    return (
      <div className={classes.root}>
        <div className={classes.dpInput}>
          <CurrencyInput
            name="downPaymentDisplay"
            id="downPaymentDisplay"
            label="Down Payment"
            precision={0}
            value={downPayment}
            field={{
              name: "",
              onChange: () => {},
              onBlur: () => {},
              value: null,
            }}
            form={{
              errors: [],
              setFieldValue: (name, value) => {
                this.calculatePercentfromValues(value);
              },
              setFieldTouched: () => {},
              touched: false,
            }}
          />
        </div>
        <div>
          <NumberIncrement
            name="percentage"
            id="percentage"
            className={classes.percent}
            label="% Down"
            field={{
              name: "",
              onChange: () => {},
              onBlur: () => {},
              value: null,
            }}
            form={{
              errors: [],
              setFieldValue: (name, value) => {
                this.calculateValuesFromPercent(value);
              },
              setFieldTouched: () => {},
              touched: false,
            }}
            value={percentage}
          />
        </div>
        <input
          type="hidden"
          name={this.props.field.name}
          id={this.props.field.name}
          value={downPayment}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    [theme.breakpoints(644)]: {
      justifyContent: "center",
    },
  },
  dpInput: {
    marginRight: theme.spacing.unit * 0.75,
  },
  percent: {
    alignItems: "stretch",
    height: "48px",
    "& button, input": {
      height: "auto",
    },
    "& input": {
      width: "85px",
    },
  },
});

export default withStyles(styles)(DownPayment);
